/** @module WBS/WarningStateRenderer */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/widget/CustomIconWithLabel",
	"csi/xml",
	"./StateColorRenderer"
], function(declare,locale,CustomIconWithLabel,xml,EnumRenderer) {

	return declare(EnumRenderer, {
		/**
		 * @override
		 * Render icon and text
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const node = ctx.getNode();
			const state = node.WEState;
			const label = locale.capitalizeResource(state);
			const stateText = xml.enumGetText(state);

			if (stateText === "CompleteLate" || stateText === "PredictedLate") {
				new CustomIconWithLabel({
					icon: stateText.toLowerCase(),
					label: label
				}).placeAt(refNode);
			} else {
				return this.inherited(arguments);
			}

			return true;
		}
	});
});